export var AuditEvent;
(function (AuditEvent) {
    AuditEvent[AuditEvent["USER_CREATE"] = 1] = "USER_CREATE";
    AuditEvent[AuditEvent["USER_UPDATE"] = 2] = "USER_UPDATE";
    AuditEvent[AuditEvent["USER_DELETE"] = 4] = "USER_DELETE";
    AuditEvent[AuditEvent["USER_ROLE_UPDATE"] = 8] = "USER_ROLE_UPDATE";
    AuditEvent[AuditEvent["SUBMISSION_CREATE"] = 16] = "SUBMISSION_CREATE";
    AuditEvent[AuditEvent["SUBMISSION_UPDATE"] = 32] = "SUBMISSION_UPDATE";
    AuditEvent[AuditEvent["SUBMISSION_DELETE"] = 64] = "SUBMISSION_DELETE";
    AuditEvent[AuditEvent["SUBMISSION_BULK_DELETE"] = 128] = "SUBMISSION_BULK_DELETE";
    AuditEvent[AuditEvent["SUBMISSION_ENJOYMENT_DELETE"] = 256] = "SUBMISSION_ENJOYMENT_DELETE";
    AuditEvent[AuditEvent["SUBMISSION_MERGE"] = 512] = "SUBMISSION_MERGE";
    AuditEvent[AuditEvent["PENDING_SUBMISSION_UPDATE"] = 1024] = "PENDING_SUBMISSION_UPDATE";
    AuditEvent[AuditEvent["PENDING_SUBMISSION_DELETE"] = 2048] = "PENDING_SUBMISSION_DELETE";
    AuditEvent[AuditEvent["PENDING_SUBMISSION_DELETE_ALL"] = 4096] = "PENDING_SUBMISSION_DELETE_ALL";
    AuditEvent[AuditEvent["TAG_CREATE"] = 8192] = "TAG_CREATE";
    AuditEvent[AuditEvent["TAG_UPDATE"] = 16384] = "TAG_UPDATE";
    AuditEvent[AuditEvent["TAG_DELETE"] = 32768] = "TAG_DELETE";
    AuditEvent[AuditEvent["TAG_VOTES_DELETE"] = 65536] = "TAG_VOTES_DELETE";
    AuditEvent[AuditEvent["PASSWORD_RESET_LINK_CREATE"] = 131072] = "PASSWORD_RESET_LINK_CREATE";
    AuditEvent[AuditEvent["ROLE_CREATE"] = 262144] = "ROLE_CREATE";
    AuditEvent[AuditEvent["ROLE_UPDATE"] = 524288] = "ROLE_UPDATE";
    AuditEvent[AuditEvent["ROLE_DELETE"] = 1048576] = "ROLE_DELETE";
    AuditEvent[AuditEvent["PLATFORMER_LIST_LEVEL_CREATE"] = 2097152] = "PLATFORMER_LIST_LEVEL_CREATE";
    AuditEvent[AuditEvent["PLATFORMER_LIST_LEVEL_UPDATE"] = 4194304] = "PLATFORMER_LIST_LEVEL_UPDATE";
    AuditEvent[AuditEvent["PLATFORMER_LIST_LEVEL_DELETE"] = 8388608] = "PLATFORMER_LIST_LEVEL_DELETE";
    AuditEvent[AuditEvent["PACK_CREATE"] = 16777216] = "PACK_CREATE";
    AuditEvent[AuditEvent["PACK_UPDATE"] = 33554432] = "PACK_UPDATE";
    AuditEvent[AuditEvent["PACK_DELETE"] = 67108864] = "PACK_DELETE";
    AuditEvent[AuditEvent["PACK_LEVEL_CREATE"] = 134217728] = "PACK_LEVEL_CREATE";
    AuditEvent[AuditEvent["PACK_LEVEL_DELETE"] = 268435456] = "PACK_LEVEL_DELETE";
    AuditEvent[AuditEvent["USER_BAN_CREATE"] = 536870912] = "USER_BAN_CREATE";
    AuditEvent[AuditEvent["USER_BAN_REVOKE"] = 1073741824] = "USER_BAN_REVOKE";
    AuditEvent[AuditEvent["ACHIEVEMENT_CREATE"] = 2147483648] = "ACHIEVEMENT_CREATE";
    AuditEvent[AuditEvent["ACHIEVEMENT_UPDATE"] = 4294967296] = "ACHIEVEMENT_UPDATE";
    AuditEvent[AuditEvent["ACHIEVEMENT_DELETE"] = 8589934592] = "ACHIEVEMENT_DELETE";
    AuditEvent[AuditEvent["CRITICAL_SUBMISSION"] = 17179869184] = "CRITICAL_SUBMISSION";
})(AuditEvent || (AuditEvent = {}));
